<section class="bf-price-list">

  <h2 class="bf-price-list__title">ÁRLISTA</h2>

  <div class="bf-price-list__grid">

    <ul class="bf-price-list__column">
      @for (item of leftItems; track item.name) {
        <li class="bf-price-list__item">
          <div class="bf-price-list__row">
            <span class="bf-price-list__name">{{ item.name }}</span>
            <span class="bf-price-list__price">{{ item.price }}</span>
          </div>
          <p class="bf-price-list__description">{{ item.description }}</p>
        </li>
      }
    </ul>

    <ul class="bf-price-list__column bf-price-list__column--right">
      @for (item of rightItems; track item.name) {
        <li class="bf-price-list__item">
          <div class="bf-price-list__row">
            <span class="bf-price-list__name">{{ item.name }}</span>
            <span class="bf-price-list__price">{{ item.price }}</span>
          </div>
          <p class="bf-price-list__description">{{ item.description }}</p>
        </li>
      }
    </ul>

  </div>

  <p class="bf-price-list__note">
    Az árak forintban értendők és az ÁFA-t tartalmazzák.
  </p>

</section>
